// Drawn icons (design language, "Drawn icons"): one even ink line, 1.5px at
// 24px, rounded ends, no fill, in the current text color so they follow the
// theme. Used only for real things from the kitchen and garden: the four
// tabs, and on Home a crate for a CSA box and a stall for a market. These
// are the canvas placeholders that set the brief; a finished set is on the
// "Later" list of the build handoff.
import type { NavIcon as NavIconName } from "../lib/navigation";

export type DrawnIconName = NavIconName | "crate" | "stall";

const PATHS: Record<DrawnIconName, string[]> = {
  home: ["M4 11l8-7 8 7v9H4z", "M10 20v-5h4v5"],
  plan: ["M5 6h14v14H5z", "M5 10h14", "M9 4v4", "M15 4v4"],
  groceries: ["M4 10h16l-2 9H6z", "M8 10l4-6 4 6"],
  recipes: ["M12 6c-2-1.5-5-1.5-8 0v12c3-1.5 6-1.5 8 0 2-1.5 5-1.5 8 0V6c-3-1.5-6-1.5-8 0z", "M12 6v12"],
  crate: ["M4 9l8-4 8 4v8l-8 4-8-4z", "M4 9l8 4 8-4", "M12 13v8"],
  stall: [
    "M4 10l2-5h12l2 5",
    "M4 10c0 1.5 1.2 2.5 2.7 2.5S9.3 11.5 9.3 10c0 1.5 1.2 2.5 2.7 2.5s2.7-1 2.7-2.5c0 1.5 1.2 2.5 2.6 2.5S20 11.5 20 10",
    "M6 12.5V20h12v-7.5",
  ],
};

export function DrawnIcon({ name, size = 24 }: { name: DrawnIconName; size?: number }) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0 }}
    >
      {PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}

export const NavIcon = DrawnIcon;
